/**
 * v1_907: one rule for a resolved red line, shared by the server (api/_review-merge.js)
 * and the dashboard. A resolution is the officer's record: who, when and why. It is
 * copied, never rebuilt, so the name, the time and the reason stay exactly as recorded.
 */

// Two resolutions are the same record when the same officer made them at the same moment.
// Every resolution on the record, current and kept, once each: what the Audit Record
// counts and lists, from one array, so the count always equals the lines listed.
export function allResolutions(review) {
  const out = [];
  const rev = (review && typeof review === 'object') ? review : {};
  for (const r of [...(Array.isArray(rev.redLines) ? rev.redLines : []), ...(Array.isArray(rev.resolvedRedLines) ? rev.resolvedRedLines : [])]) {
    if (!r || typeof r !== 'object' || !r.resolved) continue;
    if (out.some(o => sameResolution(o.resolved, r.resolved) && String(o.issue) === String(r.issue))) continue;
    out.push(r);
  }
  return out;
}

export const sameResolution = (a, b) => !!a && !!b && String(a.by || '') === String(b.by || '') && String(a.at || '') === String(b.at || '');

// The kept list a write must carry: every kept resolution from the stored review and from
// the copy being written, once each. The dashboard writes the review back from its own
// copy when the officer resolves, reopens or answers; if that copy is older than a review
// the server has since written, the stored kept list would otherwise be overwritten.
// A resolution shown on a current red line is not repeated in the kept list.
export function mergeKeptResolutions(stored, local, currentRedLines = []) {
  const shown = (Array.isArray(currentRedLines) ? currentRedLines : []).filter(r => r && typeof r === 'object' && r.resolved);
  const out = [];
  for (const r of [...(Array.isArray(stored) ? stored : []), ...(Array.isArray(local) ? local : [])]) {
    if (!r || typeof r !== 'object' || !r.resolved) continue;
    if (shown.some(s => sameResolution(s.resolved, r.resolved))) continue;
    if (out.some(o => sameResolution(o.resolved, r.resolved) && String(o.issue) === String(r.issue))) continue;
    out.push(r);
  }
  return out;
}
